/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  const isDebug = () => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const value = params.get("debug");

    return !!value;
  };

  const refreshCart = async () => {
    const section = $("#SiteHeader");
    const sectionId = section.data("sectionId");

    const cartSection = await fetch("/?section_id=" + sectionId)
      .then((res) => res.text())
      .then($.parseHTML);

    const drawerId = "#cart-drawer";

    const content = $(cartSection)
      .find(drawerId)
      .first()
      .children()
      .first()
      .html();

    const drawer = $(drawerId);

    drawer.html(content).addClass("is-open");
  };

  const onReady = (fn) => {
    if (["complete", "interactive"].includes(document.readyState)) {
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  };

  const addLanguageSelector = () => {

    const path = window.location.pathname
      .split("/")
      .filter(item => !!item)
      .filter((item, index) => { 

        console.log({ item, index })
        
        return index || item.length !== 2
      })
      .join("/");

    console.log({ path })

    
    $(".select-popout-header a").each(function(i) {

      // Links to another storefront domain (e.g. joyagear.de) keep their href.
      if ($(this).is('[data-external]')) return;

      const targetLang = $(this).attr('lang')
      const targetPath = window.location.origin + "/" + [targetLang !== 'nl' ? targetLang : '', path].filter(item => !!item).join("/")
      $(this).attr('href', targetPath)
      $(this).on('click', () => window.location.href = targetPath);
      
    });
    
    $(".select-popout__toggle__header").on("click", () => {
      
      $(".select-popout-header .select-popout__list").toggleClass("select-popout__list--visible")
    
    })
  }

  const addB2BMenu = () => {
    const button = $(".add-to-cart-btn")[0];

    if (!(button && button.getAttribute("bss-ajax-cart-checkout-event"))) {
      return;
    }

    const form = button.parentNode;

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopPropagation();

      (async () => {
        const items = [];

        for (const entry of new FormData(form).entries()) {
          const key = /\[([A-z]*)\]/.exec(entry[0])[1];
          const index = Number(/\[([0-9]*)\]/.exec(entry[0])[1]);
          const value = Number(entry[1]);

          items[index] ??= {};

          items[index][key] = value;
        }

        const result = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: items.filter(({ quantity }) => !!quantity),
          }),
        }).then((res) => res.json());

        await refreshCart();

        const overlay = "js-drawer-open-cart";
        $("body").addClass(overlay);
        const hide = () => {
          $("body").removeClass(overlay);
        };
        $(".drawer__overlay").click(hide);
        $(".cart-drawer__close").click(hide);
      })();
    });
  };

  onReady(() => {
    setTimeout(() => {
      addB2BMenu();
      addLanguageSelector();
    }, 500);
  });
})();
